/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type GetMarketplacePropertySellerDisclosuresQueryVariables = Exact<{
  addressId: Types.Scalars['UUID']['input'];
}>;


export type GetMarketplacePropertySellerDisclosuresQuery = { marketplace: { sellerDisclosuresDownloadUrl: Types.Scalars['URL']['output'] | null } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const GetMarketplacePropertySellerDisclosuresDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetMarketplacePropertySellerDisclosures($addressId: UUID!) {
  marketplace {
    sellerDisclosuresDownloadUrl(addressId: $addressId)
  }
}
    `) as unknown as TypedDocumentString<GetMarketplacePropertySellerDisclosuresQuery, GetMarketplacePropertySellerDisclosuresQueryVariables>;